<template>
  <div class="quizanswerviewer" v-if="answerToShow.id">
    <div
      class="is-pulled-right control has-addons"
      style="margin-top: 20px"
    >
      <button
        class="button is-success is-small"
        v-if="CanBeUpdated"
        @click="showModalEdit = true"
      >
        Editar
      </button>
      <pop-confirm
        content="Você tem certeza?"
        :show-cancel="false"
        :on-ok="deleteAnswer"
        v-if="CanBeDeleted"
      >
        <button
          class="button is-danger is-small"
          v-if="CanBeDeleted"
        >
          Apagar Tradução
        </button>
      </pop-confirm>
    </div>
    <div class="answer">
      <div class="field">
        <h4 class="title is-5" style="font-weight: bold">{{answerToShow.text}}</h4>
        <h4 class="title is-5" v-if="answerToShow.language === 'pt'">
          <b>Correta: </b>
          <span v-if="answerToShow.correct">Sim</span>
          <span v-else>Não</span>
        </h4>
      </div>
    </div>
    <modal
      title="Editar Resposta"
      :width="600"
      :is-show="showModalEdit"
      :show-footer="false"
      transition="fadeDown"
      @close="showModalEdit = false"
      class="modal-edit-answer"
    >
      <answer-form
        :form-data="answerToShow"
        :on-submit="editAnswer"
        :is-disabled="isFormDisabled"
        :is-loading="isFormDisabled"
        :disabled-fields="{ correct: true }"
        button-label="Atualizar"
      >
        <div class="field" slot="after-form">
          <h4 class="title is-5">
            <b>Correta: </b>
            <span v-if="answerToShow.correct">Sim</span>
            <span v-else>Não</span>
            <b-switch
              size="small"
              :checked="answerToShow.correct"
              :on-change="updateAnswer"
              :disabled="isFormDisabled"
              v-if="CanBeEdited"
            />
          </h4>
        </div>
      </answer-form>
    </modal>
    <div class="deleting" v-if="isDeleting">
      <button
        disabled="disabled"
        class="button is-loading is-disabled is-white"
      >
        ...
      </button>
    </div>
  </div>
</template>

<script>
import AnswerForm from './forms/AnswerForm'
import { UpdateQuizAnswer, DeleteQuizAnswer, UpdateQuizAnswerLanguage } from '../api/quiz'
import { prepareFormData } from '../helpers'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'QuizAnswerViewer',
  components: { AnswerForm },
  props: {
    answer: {
      type: Object,
      required: true
    },
    CanBeEdited: {
      type: Boolean,
      default: false
    },
    CanBeDeleted: {
      type: Boolean,
      default: false
    },
    CanBeUpdated: {
      type: Boolean,
      default: false
    },
    OnDelete: {
      type: Function,
      required: false
    }
  },
  data () {
    return {
      showModalEdit: false,
      isFormDisabled: false,
      answerToShow: {},
      answerId: '',
      isDeleting: false
    }
  },
  mounted () {
    this.answerToShow = this.answer
    this.answerId = this.answer.id
  },
  computed: {
    ...mapGetters([
      'PlaceQuizes'
    ])
  },
  methods: {
    ...mapActions(['deleteQuizAnswerTranslation']),
    updateAnswer (value) {
      // console.log(data)
      const { id, PlaceQuizId, quizId } = this.answerToShow
      let answerUpdated = {
        correct: value
      }
      this.isFormDisabled = true
      UpdateQuizAnswer(
        prepareFormData(answerUpdated),
        PlaceQuizId,
        quizId,
        id
      )
        .then(
          success => {
            this.answerToShow = {
              ...this.answerToShow,
              correct: value,
              ...success.data
            }
            this.isFormDisabled = false
            console.log(this.answerToShow)
            // this.$notify.open({
            //   type: 'success',
            //   content: 'Resposta atualizada com sucesso.',
            //   duration: 10000
            // })
          },
          error => {
            console.log(error.response)
            this.isFormDisabled = false
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível atualizar a Resposta.',
              duration: 10000
            })
          }
        )
    },
    editAnswer (data) {
      let formData = {
        text: data.text
      }
      this.isFormDisabled = true
      UpdateQuizAnswerLanguage(
        formData,
        this.$route.params.id,
        data.quizId,
        data.id,
        data.languageId
      )
        .then(
          success => {
            this.isFormDisabled = false
            // console.log(success.data)
            this.answerToShow = { ...this.answerToShow, text: data.text }
            this.showModalEdit = false
            this.$notify.open({
              type: 'success',
              content: 'Resposta atualizada com sucesso.',
              duration: 10000
            })
          },
          error => {
            console.log(error.response)
            this.isFormDisabled = false
            this.showModalEdit = false
            this.$notify.open({
              type: 'danger',
              content: 'Não foi possível atualizar a Resposta.',
              duration: 10000
            })
          }
        )
    },
    delAnswer () {
      this.$modal.confirm({
        content: 'Tem certeza que deseja apagar esta Resposta?',
        title: 'Confirmação',
        onOk: () => {
          this.isDeleting = true
          const { id, PlaceQuizId, quizId } = this.answerToShow
          DeleteQuizAnswer(
            PlaceQuizId,
            quizId,
            id
          )
            .then(
              success => {
                this.isDeleting = false
                if (this.OnDelete) {
                  this.OnDelete(this.answer)
                }
                this.answerToShow = {}
                this.$notify.open({
                  type: 'success',
                  content: 'Resposta apagada com sucesso.',
                  duration: 10000
                })
              },
              error => {
                console.log(error.response)
                this.isDeleting = false
                this.$notify.open({
                  type: 'danger',
                  content: 'Não foi possível apagar a Resposta.',
                  duration: 10000
                })
              }
            )
        }
      })
    },
    async deleteAnswer () {
      const placeId = this.$route.params.id
      const quizId = this.PlaceQuizes['pt'][0].id
      const answerId = this.answerToShow.id
      // const id = this.answerToShow.languageId || this.answerToShow.id
      // const answerId = this.answerToShow.quizAnswerId
      const id = this.answerToShow.languageId
      // console.log({data, id, quizId, placeId, language: data.language})
      try {
        await this.deleteQuizAnswerTranslation({id, answerId, quizId, placeId, language: this.answerToShow.language})
        this.$notify.open({
          type: 'success',
          content: 'Resposta do Desafio traduzido com sucesso!',
          duration: 10000
        })
      } catch (error) {
        console.log(error)
        console.log(error.response)
        this.$notify.open({
          type: 'danger',
          content: 'Não foi possível traduzir a Resposta do Desafio.',
          duration: 10000
        })
      }
    }
  }
}
</script>

<style lang="scss">
.quizanswerviewer+.quizanswerviewer {
  border-top: 1px solid #ccc;
}
.quizanswerviewer {
  position: relative;
  .answer {
    padding: 20px;
    .field {
      border-bottom: none;
      margin-bottom: 0;
      padding: 0;
    }
    .field+.field {
      margin: 20px 0
    }
  }
  .deleting {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(250, 250, 250, .7);
    display: flex;
    align-items: center;
    justify-content: center;
    .button.is-loading {
      height: 60px;
      &:after {
        margin-top: -20px;
        width: 40px;
        height: 40px;
      }
    }
  }
}
.modal-edit-answer {
  .field-correct {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuizAnswerViewer.vue